import React, {Fragment, useEffect, useState} from 'react';
import RNUFormService from "../../../../services/RNUFormService";
import FormService from "../../../../services/FormsService";

import Color from "color";


const TemplateCUAUrba3Demo = (props) => {
    const rnuFormService = new RNUFormService()
    const formService = new FormService();
    const [items, setItems]= useState([])
    const [items1, setItems1]= useState()
    const [items2, setItems2]= useState()
    const [items3, setItems3]= useState()
    const [items4, setItems4]= useState()
    const [annexes, setAnnexes] = useState();

    const fetchData = rnuFormService.getData('risque')
    const fetchData1 = rnuFormService.getData('servitude')
    const fetchData2 = rnuFormService.getData('prescription')
    const fetchData4 = rnuFormService.getData('servitude2')

    useEffect(()=>{


    }, [items, items1, items2, items3, items4])


    useEffect(()=>{
        //console.log("fetche risque",fetchData);
        (fetchData)?setItems(fetchData):null;
        setAnnexes(formService.getEntityAnnexes())
    },[fetchData])

    useEffect(()=>{
        (fetchData1)?setItems1(fetchData1):null;
    },[fetchData1])

    useEffect(()=>{
        (fetchData2)?setItems2(fetchData2):null;
    },[fetchData2])

    useEffect(()=>{
        (fetchData4)?setItems4(fetchData4):null;
    },[fetchData4])



    const renderRow=(item,index, parseJson=false)=>{
        (parseJson && item?.data_doc)?item=JSON.parse(item.data_doc)[0]:null;
        return((item?.libelle)?
            <Fragment key={index}>
                <strong>Lorem ipsum dolor sit amet, consectetur. </strong><br/>
            </Fragment>
            : (item?.libelle_1 )?
                    <Fragment key={index}>
                        <strong>Demo</strong>
                        {(item.libelle_2)?
                            <span> - Lorem ipsum dolor.</span>
                            :null
                        }
                        <br/>
                    </Fragment>
                    :null
        )
    }

    return (
        <div className="ue-section">
            <div>
                <div className="text-left text-underline">
                    <h3>{(props.formtype !== 'ru') ?'ARTICLE 3 - ':null}Servitudes et prescriptions</h3>
                </div>
                <div>
                 - Le terrain est grevé des servitudes et des prescriptions suivantes :
                    <br/>
                    {(items && items?.length>0)?
                        <div style={{"paddingLeft": "20px"}}>
                            {items.map((item,index)=>{
                                return(renderRow(item, index))
                                })
                            }
                        </div>
                        :null
                    }
                    {(items1 && items1?.length>0)?
                        <div style={{"paddingLeft": "20px"}}>
                            <br/>
                            {items1.map((item, index) => {
                                return (renderRow(item, index))
                            })
                            }
                        </div>
                        :null
                    }
                    {(items2 && items2?.length>0)?
                        <div style={{"paddingLeft": "20px"}}>
                            <br/>
                            {items2.map((item, index) => {
                                return (renderRow(item, index))
                            })
                            }
                        </div>
                        :null
                    }
                    {(items3 && items3?.length>0)?
                        <div style={{"paddingLeft": "20px"}}>
                        <br/>
                        {items3.map((item, index) => {
                            return (renderRow(item, index))
                        })
                        }
                    </div>
                    :null
                    }
                    {(items4 && items4?.length>0)?
                        <div style={{"paddingLeft": "20px"}}>
                            <br/>
                            {items4.map((item, index) => {
                                return (renderRow(item, index))
                            })
                            }
                        </div>
                        :null
                    }
                </div>

            </div>
        </div>
    );
};

export default TemplateCUAUrba3Demo

